/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class ActionRequestStateBeforeService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'State Before\' loaded');
    }
}

export { ActionRequestStateBeforeService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestStateBeforeService.js